import { render } from "./MrpList.vue?vue&type=template&id=600ff6aa&scoped=true"
import script from "./MrpList.vue?vue&type=script&lang=js"
export * from "./MrpList.vue?vue&type=script&lang=js"

import "./MrpList.vue?vue&type=style&index=0&id=600ff6aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600ff6aa"]])

export default __exports__